import {Box, Link, Typography} from '@mui/material';
import {Link as RouterLink} from 'react-router';
import {useGetCollection} from '@src/api/catalog';
import {mergeWithDefaults, useGetConfigurations} from '@src/api/configurations';
import LoadingMessage from '@src/components/common/LoadingMessage';
import {ErrorMessage} from '@src/components/ui/message-container.tsx';
import useVisualizationParams from '@src/hooks/useVisualizationParams.ts';

const LayersPanelTitle = () => {
  const {configurationId, collectionId} = useVisualizationParams();
  const {
    isLoading: isLoadingConfigurations,
    data: configuration,
    error: configurationsError,
  } = useGetConfigurations({
    select: data =>
      mergeWithDefaults(data).find(config => config.id === configurationId),
  });

  const {
    data: collection,
    isLoading: isLoadingCollections,
    error: collectionsError,
  } = useGetCollection(collectionId);

  if (isLoadingConfigurations || isLoadingCollections) {
    return (
      <LoadingMessage rootProps={{sx: {blockSize: 'auto', paddingBlock: 2}}} />
    );
  }

  const error = configurationsError || collectionsError;
  if (error) {
    return (
      <ErrorMessage>
        <Typography variant="h6" color="inherit" gutterBottom>
          {error.message}
        </Typography>
      </ErrorMessage>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        inlineSize: '100%',
        paddingBlock: 1,
      }}
    >
      <Typography
        variant="overline"
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Link
          to="#"
          component={RouterLink}
          sx={{textDecoration: 'underline', color: 'text.primary'}}
        >
          {configuration?.name}
        </Link>{' '}
        /
      </Typography>
      <Typography
        variant="h6"
        sx={{
          textOverflow: 'ellipsis',
          width: '100%',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textAlign: 'center',
          lineHeight: 1.2,
        }}
      >
        {collection?.title}
      </Typography>
    </Box>
  );
};

export default LayersPanelTitle;
